import React from 'react';
import './Services.css';

const servicesData = [
  {
    img: require('../assets/images/IMG_3313.jpg'),
    title: 'Electrical Help',
    description: 'Minor electrical work, including fixtures, fans, and switches.',
  },
  {
    img: require('../assets/images/5208827021537443541.jpg'),
    title: 'Drywall Repair',
    description: 'Patching holes, texturing, and painting.',
  },
  {
    img: require('../assets/images/IMG_3369.jpg'),
    title: 'TV Mounting',
    description: 'Secure TV installation, wire concealment, and leveling.',
  },
  {
    img: require('../assets/images/IMG_3572.jpg'),
    title: 'Furniture Assembly',
    description: 'IKEA, Wayfair, Amazon - we build it all.',
  },
  {
    img: require('../assets/images/5208827021537443543.jpg'),
    title: 'Plumbing',
    description: 'Faucet replacement, leak fixes, and sink installation.',
  },
  {
    img: require('../assets/images/IMG_4097.PNG'),
    title: 'Mounting & Hanging',
    description: 'Mirrors, pictures, curtains, and shelves.',
  },
  {
    img: require('../assets/images/IMG_3145.jpg'),
    title: 'Appliance Repair & Installation',
    description: 'Washers, dryers, dishwashers, and microwaves.',
  },
  {
    img: require('../assets/images/5208827021537443542.jpg'),
    title: 'General Handyman',
    description: 'Small repairs and maintenance around the house.',
  },
  {
    img: require('../assets/images/photo_2025-10-15_14-21-10.jpg'),
    title: 'Fence Repair & Installation',
    description: 'New fence building, post replacement, and panel repairs.',
  },
];

const Services = () => {
  return (
    <section className="services-section">
      <h2 className="services-title">Our Services</h2>
      <div className="services-grid">
        {servicesData.map((service, index) => (
          <div className="service-card" key={index}>
            <div className="service-image-container">
              <img
                src={service.img}
                alt={`${service.title} services in Northridge - HandyFixWise`}
                className="service-image"
              />
            </div>
            <div className="service-content">
              <h3 className="service-card-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <a href="#contact" className="service-link">Get a Quote</a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
